/**
 * Created by ITShpere on 11/22/2021.
 */
export const GET_MEDIA_VIDEOS = 'GET_MEDIA_VIDEOS';
export const GET_MEDIA_VIDEOS_SUCCESS = 'GET_MEDIA_VIDEOS_SUCCESS';
export const GET_MEDIA_VIDEOS_FAILURE = 'GET_MEDIA_VIDEOS_FAILURE';
export const SEARCH_MEDIA_VIDEOS = 'SEARCH_MEDIA_VIDEOS';